<script lang="ts" setup>
import { learning } from '@/lib/learning';
import { computed, ref } from 'vue';

const url = computed(() => learning.url);
const show = ref(false);
let oldHref = document.location.href;

function open() {
	show.value = true;
}
function close() {
	show.value = false;
}
const observeUrlChange = () => {
	const body = document.querySelector('body')!;
	const observer = new MutationObserver(() => {
		if (oldHref !== document.location.href) {
			oldHref = document.location.href;
			learning.changeHref();
		}
	});
	observer.observe(body, { childList: true, subtree: true });
};

window.addEventListener('load', observeUrlChange);
learning.changeHref();
</script>
<template>
	<a v-if="!!url" class="link-dark" @click.prevent="open()" href="#">
		<i class="fa-regular fa-circle-question"></i>
	</a>

	<div
		style="--bs-offcanvas-width: 75vw; min-width: 320px; max-width: 1400px"
		class="offcanvas offcanvas-end"
		:class="{ show: show }"
		tabindex="-1"
	>
		<button type="button" class="btn-close position-absolute p-4 bg-body-secondary" @click="close()"></button>
		<div class="offcanvas-body p-0" style="overflow-y: hidden">
			<iframe v-if="show" :src="show ? url : undefined" style="width: 100%; height: 100%"></iframe>
		</div>
	</div>
	<div v-if="show" class="offcanvas-backdrop fade show"></div>
</template>
<style scoped>
.btn-close {
	opacity: 1 !important;
	box-sizing: border-box;
	border-radius: 50% 0 0 50%;
	transform: translate(-100%, 50%);
}
</style>
